// extracted by mini-css-extract-plugin
export default {"myHeader":"Header_myHeader__YvXxJ"};